<template>
    <table :class="getCSSClass('privilege-picker-container')">
        <tr v-for="module in modules"
             :class="getCSSClass('privilege-picker-row')">
            <td  :class="getCSSClass('privilege-picker-module-label')" v-html="module.name"></td>
            <td v-for="aLabel, aValue in accesslevels"  :class="getCSSClass('privilege-picker-input-container')">
                <label :class="getCSSClass('privilege-picker-accesslevel-label')">
                    <input :value="aValue"
                           type="radio"
                           :id="'privilegepicker-'+module.id.toString()+'-'+aValue.toString()"
                           v-model="internalValue[module.id]"
                           v-on:change="emitValue" style="margin-right: .5rem">
                    {{ aLabel }}
                </label>
            </td>
        </tr>
    </table>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            jobpositionId: {},
            presets: {type: Array},
            modules: {type: Array},
            accesslevels: {type: Array},
            value: {type: Object},
        },
        data: function () {
            return {
                internalValue: {type: Object},
            }
        },
        created: function() {
            this.internalValue = {...this.value};
            this.modules.forEach((m) => {
                if (typeof(this.internalValue[m.id]) == 'undefined') {
                    Vue.set(this.internalValue, m.id, this.currentPreset[m.id]);
                }
            });
            this.$emit('input', this.internalValue)
        },
        mounted() {
        },
        methods: {
            emitValue: function() {
                this.$emit('input', this.internalValue)
            }
        },
        computed: {
            currentPreset: function() {
                let result = {};
                this.presets.forEach((p) => {
                    if (p.jobposition_id == this.jobpositionId.toString()) {
                        result[p.softwaremodule_id] = p.accesslevel;
                    }
                });

                return result;
            }
        },
        watch: {
            value: function() {
                this.internalValue = {...this.value};
            }
        }

    }
</script>
